import '../../modules/mode-components';

import * as angular from 'angular';

import template from './status-bar.html';

class StatusBarController {
  static $inject = ['$scope', '$log'];

  private state: Object;

  constructor(
    private $scope,
    private $log
  ) {}
}

const StatusBar: angular.IComponentOptions = {
  bindings: {
    state: '<',
  },
  template: template,
  transclude: {
    warning: '?warning',
    error: '?error',
    running: '?running',
    ready: '?ready',
    alert: '?alert',
    loading: '?loading',
    success: '?success',
    cancelled: '?cancelled',
  },
  controller: StatusBarController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('statusBar', StatusBar);
